import { DatePipe } from '@angular/common';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormControl, NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { TableColumn } from 'src/app/home/table/TableColumn';
import { Kpimaster } from 'src/app/models/commission/kpimaster.model';
import { CustomHttpRespone } from 'src/app/models/customhttpresponse/custom-http-response';
import { ExcelHeadersModel } from 'src/app/models/excelheaders/excelheaders.model';
import { AuthGaurdService } from 'src/app/service/auth-gaurd.service';
import { CommissionService } from 'src/app/service/commission.service';
import { ExcelHeadersService } from 'src/app/service/excelheaders.service';
import { ExportExcelService } from 'src/app/service/export-excel.service';
import { GlobalService } from 'src/app/service/global.service';
import { KpimasterService } from 'src/app/service/kpimaster.service';
import { LoggerService } from 'src/app/service/logger.service';
import { NotificationType } from '../../enum/notification-type.enum';
import { NotificationService } from '../../service/notification.service';
import { DependentScoreKpiModel } from 'src/app/models/commission/dependentscore-kpi.model';

@Component({
  selector: 'app-kpimaster',
  templateUrl: './kpimaster.component.html',
  styleUrls: ['./kpimaster.component.css']
})
export class KpimasterComponent implements OnInit {



  public kpiMasterModel = new Kpimaster();
  public kpiMasterModel1 = new Kpimaster();
  public kpiMasterModel2 = new Kpimaster();
  public kpiMasterModel3 = new Kpimaster();
  public kpiMasterModel4 = new Kpimaster();
  public kpiMasterModel5 = new Kpimaster();
  public kpiMasterModel6 = new Kpimaster();

  public createKpiModel = new Kpimaster();

  public kpiModels: Kpimaster[] = [];
  public byKpiModels: Kpimaster[] = [];
  public kpiEditModels: Kpimaster[] = [];
  public dependKpiEditModels: Kpimaster[] = [];

  public kpiid: number;
  public effdate: Date;
  public proType: string;
  public cat: string;

  public refreshing: boolean;
  private subscriptions: Subscription[] = [];
  public kpis: Kpimaster[];
  public dependsKpis: Kpimaster[];
  public excelKpis: Kpimaster[];
  public kpicalctypesdata: Kpimaster[];
  public editkpicalctypesdata: Kpimaster[];
  public checkData: Kpimaster[] = [];
  public duplicatecheckData: Kpimaster[] = [];
  public filteredkpis: Kpimaster[];
  public inactivekpis: Kpimaster[];
  public productsData: Kpimaster[] = [];
  public productTypesData: Kpimaster[] = [];
  public editProductTypesData: Kpimaster[] = [];
  public productCatData: Kpimaster[] = [];
  public translateMasterdata: Kpimaster[] = [];
  public kpiTypeOnedata: Kpimaster[] = [];
  public feedTypeData: Kpimaster[] = [];
  public comboStringData: Kpimaster[] = [];
  public wstatStringData: Kpimaster[] = [];
  public kpiTypeTwodata: Kpimaster[] = [];
  public kpi_name: string;
  public selectedProductType: string;

  public filteredStreets: Observable<Kpimaster[]> | undefined;
  public docNames: Kpimaster[] = [];
  public filteredProductsTypeData: Kpimaster[] = [];
  public filteredEditProductsTypeData: Kpimaster[] = [];
  public editfilteredProductsTypeData: Kpimaster[] = [];
  public filteredCatData: Kpimaster[] = [];
  public duplifilteredCatData: Kpimaster[] = [];
  public editfilteredCatData: Kpimaster[] = [];
  public filteredProductsData: Kpimaster[] = [];
  public editfilteredProductsData: Kpimaster[] = [];
  public editSelectedProductsData: Kpimaster[] = [];
  public prodsData: Kpimaster[] = [];
  public control = new FormControl();
  public filteredValues: Kpimaster[] = [];
  public kpisData: Kpimaster[] = [];
  public filterKPiData: Kpimaster[] = [];
  public activeKpisData: Kpimaster[] = [];
  public productTypes: Kpimaster[];
  public productCats: Kpimaster[];
  public productProducts: Kpimaster[];
  public loggedinUser: string = '';

  public selectedKpiId: number = 0;
  public strValue: string;

  public depend: string;
  public dependentKpisList: Kpimaster[] = [];

  public isChkd: string = '';

  public selctedKpis: Kpimaster[] = [];
  public selctedInactiveKpis: Kpimaster[] = [];

  public showLoading: boolean;
  public page: string;
  public isBack: boolean = false;
  public columnsDataJson: any;
  public columnsExcelData: any;
  public columnsExcelData1: ExcelHeadersModel[] = [];

  public title = 'angular-export-to-excel';
  public ordersTableExcelHeaderColumns: TableColumn[];

  public dataForExcel = [];

  public fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  public fileExtension = '.xlsx';
  public fileName: string = 'KPIData';

  public isShowActiveStatus: boolean = true;
  public isShowInactiveStatus: boolean = false;

  public checkedactive: boolean = false;
  public checkedinactive: boolean = false;
  public isChecked: boolean = false;

  public isCustomRoutineShown: boolean;
  public isEditCustomRoutineShown: boolean;

  public isProductsShown: boolean = false;
  public isKpiShown: boolean = false;
  public isComboShown: boolean = false;

  public isEditProductsShown: boolean = false;
  public isEditKpiShown: boolean = false;
  public isEditComboShown: boolean = false;

  public selectedcat: string;

  public isCatShown: boolean = true;
  public isProShown: boolean = true;

  // GRID FRAMEWORK
  ordersTableColumns1: TableColumn[];
  ordersTableColumns2: TableColumn[];
  ordersTableColumns3: TableColumn[];
  ordersTableColumns4: TableColumn[];
  ordersTableColumns5: TableColumn[];
  ordersTableColumns6: TableColumn[];
  ordersTableColumns7: TableColumn[];
  columnsData: any;
  pageColumnsData: any;

  actions: any;


  checkbox: any;
  actionButtons: any;
  kpiType: string;
  clickedKpiType: string;

  originalKPIName: string;
  originalEdate: any;

  isAccessDisabled: boolean = false;
  isPageAccessDisabled: boolean = false;

  public depndntScoreKpiList: DependentScoreKpiModel[] = [];
  public depndntScoreKpiEditList: DependentScoreKpiModel[] = [];

  public kpiNamesSet = new Set<string>();
  public kpiDropdownList: Kpimaster[] = [];
  public kpiDropdownEditList: Kpimaster[] = [];
  public depndntScoreKpiModel1 = new DependentScoreKpiModel();
  public depndntScoreKpiModel2 = new DependentScoreKpiModel();
  public depndntScoreKpiModel = new DependentScoreKpiModel();


  constructor(private globalService: GlobalService, private router: Router, private logger: LoggerService,
    private commissionService: CommissionService, private kpimasterService: KpimasterService, private excelHeadersService: ExcelHeadersService,
    private httpService: HttpClient, private notificationService: NotificationService, private route: ActivatedRoute,
    public ete: ExportExcelService, private authgurdService: AuthGaurdService, public datepipe: DatePipe) {

    globalService._disableBackButton();
  }

  ngOnInit(): void {

    this.depndntScoreKpiModel.created_by = "";
    this.depndntScoreKpiModel.created_dt = new Date();
    this.depndntScoreKpiList.push(this.depndntScoreKpiModel);

    // Get Permissions
    this.isAccessDisabled = this.globalService._permissionCheck('kpi-master');
    //console.log(this.isAccessDisabled);

    this.isPageAccessDisabled = this.globalService._pagePermissionsCheck('kpi-master');
    console.log(this.isPageAccessDisabled);

    // added for addrow functionality
    this.kpiMasterModel.created_by = "";
    this.kpiMasterModel.created_dt = new Date();
    this.kpiMasterModel.includecount = true;
    this.kpiMasterModel.includerevenue = true;
    this.kpiModels.push(this.kpiMasterModel);
    //console.log(this.kpiMasterModel);
    this.byKpiModels.push(this.kpiMasterModel);
    this.prodsData.push(this.kpiMasterModel);

    this.init();
    this.getActiveKpis();
    this.getTranslateData();
    this.getProductTypes();
    this.getEditProductTypes();
    this.isCustomRoutineShown = false;
    this.isEditCustomRoutineShown = false;
    this.initializeExcelHeaders();
    this.initializeColumns();
    this.getKpisList();
  }

  addByKpiRow(kpiForm: NgForm) {
    const kpiObj = new DependentScoreKpiModel();
    kpiObj.kpi_name = this.depndntScoreKpiModel1.depndentKpis;
    this.depndntScoreKpiList.push(kpiObj);
  }
  public removeByKpiRow(index: any) {
    if (this.depndntScoreKpiList.length > 1) {
      if (this.depndntScoreKpiList[index].depndentKpis != null) {
        this.removeByKpiFilterData(index);
      }
      else {
        this.removeByKpiFilterData(index);
        this.depndntScoreKpiList.splice(index, 1);
      }
    } else {
      this.notificationService.sendNotification(NotificationType.WARNING, "There Is Only One Row Exist You Can't Delete.");
    }
  }
  private removeByKpiFilterData(i: any) {
    if (this.depndntScoreKpiList.length > 0) {
      const compos = this.depndntScoreKpiList[i].depndentKpis;
      this.depndntScoreKpiList.forEach((value: any, index: any) => {
        if (value.depndentKpis == compos)
          this.depndntScoreKpiList.splice(index, 1);
      })
    }
  }

  addByKpiUpdateRow(kpiForm: NgForm) {
    const kpiObj = new DependentScoreKpiModel();
    kpiObj.kpi_name = this.depndntScoreKpiModel2.chargeback_depndt_kpi_id;
    this.depndntScoreKpiEditList.push(kpiObj);
  }
  public removeByKpiUpdateRow(index: any) {
    if (this.depndntScoreKpiEditList.length > 1) {
      if (this.depndntScoreKpiEditList[index].chargeback_depndt_kpi_id != null) {
        this.removeByKpiFilterUpdateData(index);
      }
      else {
        this.removeByKpiFilterUpdateData(index);
        this.depndntScoreKpiEditList.splice(index, 1);
      }
    } else {
      this.notificationService.sendNotification(NotificationType.WARNING, "There Is Only One Row Exist You Can't Delete.");
    }
  }
  private removeByKpiFilterUpdateData(i: any) {
    if (this.depndntScoreKpiEditList.length > 0) {
      const compos = this.depndntScoreKpiEditList[i].chargeback_depndt_kpi_id;
      this.depndntScoreKpiEditList.forEach((value: any, index: any) => {
        if (value.chargeback_depndt_kpi_id == compos)
          this.depndntScoreKpiEditList.splice(index, 1);
      })
    }
  }

  public getKpisList() {
    this.kpimasterService.getDependentKpis()
      .subscribe((response: any) => {
        this.kpiDropdownList = response;
        this.kpiDropdownEditList = JSON.parse(JSON.stringify(response));;
        // console.log(this.kpiDropdownList);
        // for (let kpi of this.kpiDropdownList) {
        //   this.kpiNamesSet.add(kpi.kpi_name);
        // }
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  check(id: number): boolean {
    if (id === 0)
      return true;
    else
      return false;
  }

  public createKpi(kpiForm: NgForm): void {
    console.log(this.createKpiModel);
    console.log(this.kpiModels);
    console.log(this.byKpiModels);
    console.log(this.prodsData);

    let cp = "";
    let cv = "";

    for (let val of this.kpiModels) {
      cp = cp + val.combo_position + "~";
      cv = cv + val.combo_values + "~";
    }
    kpiForm.value.combo_position = cp;
    kpiForm.value.combo_values = cv;

    let dpndkpi = "";
    let count = "";
    let revenue = "";
    for (let val of this.byKpiModels) {
      let cnt: string;
      let rev: string;

      if (val.includecount === true) {
        cnt = "Y";
      } else if (val.includecount === false) {
        cnt = "N";
      }

      if (val.includerevenue === true) {
        rev = "Y";
      } else if (val.includerevenue === false) {
        rev = "N";
      }

      dpndkpi = dpndkpi + val.id + "~";
      count = count + cnt + "~";
      revenue = revenue + rev + "~";
    }

    kpiForm.value.id = dpndkpi;
    kpiForm.value.include_count = count;
    kpiForm.value.include_revenue = revenue;
    //console.log(kpiForm.value);

    let ptype = "";
    let pcat = "";
    let prod = "";
    for (let val of this.prodsData) {
      ptype = ptype + val.product_type + "~";
      pcat = pcat + val.dupli_cat + "~";
      prod = prod + val.dupli_pro + "~";
    }
    kpiForm.value.product_type = ptype;
    kpiForm.value.product_category = pcat;
    kpiForm.value.product = prod;

    // console.log(kpiForm.value.effective_date);

    this.showLoading = true;
    // const formData = this.kpimasterService.createKpiForm(kpiForm.value);
    //console.log("formData = " + JSON.stringify(formData));

   // console.log(this.createKpiModel);
    this.createKpiModel.combo_position = cp;
    this.createKpiModel.combo_values = cv;

    this.createKpiModel.depndentKpis = dpndkpi;
    this.createKpiModel.include_count = count;
    this.createKpiModel.include_revenue = revenue;

    this.createKpiModel.product_type = ptype;
    this.createKpiModel.product_category = pcat;
    this.createKpiModel.product = prod;

    this.createKpiModel.created_by = localStorage.getItem('CURRENT_USER_NAME_SESSION');
    this.createKpiModel.kpi_status = "Active";
    this.createKpiModel.stat = 1;

    let chargebackkpiid = "";
    for (let val of this.depndntScoreKpiList) {
      chargebackkpiid = chargebackkpiid + val.depndentKpis + "~";
    }
   // console.log(chargebackkpiid);

    this.createKpiModel.chargeback_kpiid = chargebackkpiid;

    this.kpimasterService.createKPI(this.createKpiModel).subscribe(
      (response: CustomHttpRespone) => {
        this.clickButton('closeAddKPIButton');
        this.notificationService.sendNotification(NotificationType.SUCCESS, response.message);
        // this.kpimasterService.clearCache();
        this.getActiveKpis();
        kpiForm.reset();
        this.showLoading = false;
        this.kpiModels = [];
        this.byKpiModels = [];
        this.prodsData = [];
        this.depndntScoreKpiList = [];

        this.depndntScoreKpiModel.created_by = "";
        this.depndntScoreKpiModel.created_dt = new Date();
        this.depndntScoreKpiList.push(this.depndntScoreKpiModel);

        this.kpiMasterModel.includecount = true;
        this.kpiMasterModel.includerevenue = true;

        this.kpiMasterModel.created_by = "";
        this.kpiMasterModel.created_dt = new Date();
        this.kpiModels.push(this.kpiMasterModel);
        this.byKpiModels.push(this.kpiMasterModel);
        this.prodsData.push(this.kpiMasterModel);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
        this.showLoading = false;
      }
    )

  }

  public updateKpi(kpiForm: NgForm): void {

    let cp = "";
    let cv = "";
    for (let val of this.kpiEditModels) {
      cp = cp + val.combo_position + "~";
      cv = cv + val.combo_values + "~";
    }
    this.kpiMasterModel.combo_position = cp;
    this.kpiMasterModel.combo_values = cv;

    let dpndkpi = "";
    let count = "";
    let revenue = "";
    for (let val of this.dependKpiEditModels) {
      let cnt: string;
      let rev: string;
      if (val.includecount === true) {
        cnt = "Y";
      } else if (val.includecount === false) {
        cnt = "N";
      }
      if (val.includerevenue === true) {
        rev = "Y";
      } else if (val.includerevenue === false) {
        rev = "N";
      }
      dpndkpi = dpndkpi + val.depndentKpis + "~";
      count = count + cnt + "~";
      revenue = revenue + rev + "~";
    }
    this.kpiMasterModel.depndentKpis = dpndkpi;
    this.kpiMasterModel.include_count = count;
    this.kpiMasterModel.include_revenue = revenue;
    //console.log(this.kpiMasterModel);

    let protype = "";
    let procat = "";
    let prod = "";
    for (let val of this.editSelectedProductsData) {
      protype = protype + val.product_type + "~";
      procat = procat + val.dupli_cat + "~";
      prod = prod + val.dupli_pro + "~";
    }
    this.kpiMasterModel.product_type = protype;
    this.kpiMasterModel.product_category = procat;
    this.kpiMasterModel.product = prod;

    if (this.kpiMasterModel.kpi_calc_type !== "Custom") {
      this.kpiMasterModel.custom_routine = '';
    }

    this.kpiMasterModel.stat = 2;
    this.kpiMasterModel.updated_by = localStorage.getItem('CURRENT_USER_NAME_SESSION');
    this.kpiMasterModel.created_by = localStorage.getItem('CURRENT_USER_NAME_SESSION');

    // console.log(this.kpiMasterModel);

    let chargebackkpiid = "";
    for (let val of this.depndntScoreKpiEditList) {
      chargebackkpiid = chargebackkpiid + val.chargeback_depndt_kpi_id + "~";
    }
    // console.log(chargebackkpiid);

    this.kpiMasterModel.chargeback_kpiid = chargebackkpiid;


    this.subscriptions.push(
      this.kpimasterService.updateKPI(this.kpiMasterModel).subscribe(
        (response: CustomHttpRespone) => {
          //console.log(response);
          this.clickButton('closeEditKpiModalButton');
          //this.kpimasterService.clearCache();
          this.getActiveKpis();
          this.notificationService.sendNotification(NotificationType.SUCCESS, response.message);
          this.kpiEditModels = [];
          this.dependKpiEditModels = [];
          this.editSelectedProductsData = [];

          this.depndntScoreKpiEditList = [];

          this.kpiMasterModel.combo_position = null;
          this.kpiMasterModel.combo_values = null;
          this.kpiMasterModel.depndentKpis = null;
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
    );

  }



  public getActiveKpis(): void {

    this.kpimasterService.getKpiActiveList().subscribe(
      (response: Kpimaster[]) => {
        this.kpis = response;

        console.log("getActiveKpis() TS file");

        // filter active kpis
        const filterValue = this.globalService._normalizeValue('Active');
        this.filterKPiData = this.kpis.filter(comm => this.globalService._normalizeValue(comm.kpi_status).startsWith(filterValue));
        this.filterKPiData = this.filterKPiData.filter((v, i) => this.filterKPiData.findIndex(item => item.kpi_name == v.kpi_name && item.effective_date == v.effective_date) === i);

        this.activeKpisData = JSON.parse(JSON.stringify(this.filterKPiData));
        this.kpisData = this.filterKPiData;
        //console.log(this.kpisData);
        this.excelKpis = JSON.parse(JSON.stringify(this.filterKPiData));
        //console.log(this.kpisData);
        this.getDependentKpis();
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    )
  }

  public getActiveKpisByDate(effective_date: Date): void {

    if (effective_date === null || effective_date.toString() === "") {
      console.log("effective_date  is blank");
    } else {
      this.kpimasterService.getActiveKpisByDate(effective_date).subscribe(
        (response: Kpimaster[]) => {
          this.kpis = response;
          // filter active kpis
          const filterValue = this.globalService._normalizeValue('Active');
          this.filterKPiData = this.kpis.filter(comm => this.globalService._normalizeValue(comm.kpi_status).startsWith(filterValue));
          this.filterKPiData = this.filterKPiData.sort((a, b) => (a.kpi_name < b.kpi_name) ? -1 : 1);

          this.kpisData = this.filterKPiData;
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
    }
  }
  // public getExcelActiveKpis(): void {
  //   this.subscriptions.push(
  //     this.kpimasterService.getExcelKpiActiveList().subscribe(
  //       (response: Kpimaster[]) => {
  //         this.excelKpis = JSON.parse(JSON.stringify(response));
  //         //console.log("this.excelKpis = " + this.excelKpis);
  //       }, (errorResponse: HttpErrorResponse) => {
  //         var msg: any;
  //         msg = errorResponse;
  //         this.notificationService.sendNotification(NotificationType.ERROR, msg);
  //       }
  //     )
  //   );
  // }

  init() {
    this.route.queryParams.subscribe(params => {
      this.page = params['page'];
      if (this.page === 'replicate-plan') {
        this.isBack = true;
      }
    }, (errorResponse: HttpErrorResponse) => {
      var msg: any;
      msg = errorResponse;
      this.notificationService.sendNotification(NotificationType.ERROR, msg);
    });
  }

  public getKpiId(kpiid: number, effective_date: Date, kpiType: string) {
    this.clickedKpiType = kpiType;
    console.log(this.clickedKpiType);
    if (this.clickedKpiType === "By KPI") {
      this.ordersTableColumns2 = this.ordersTableColumns5;
    } else if (this.clickedKpiType === "By Product") {
      this.ordersTableColumns2 = this.ordersTableColumns2;
      console.log(this.ordersTableColumns2);
    } else if (this.clickedKpiType === "By Combo String") {
      this.ordersTableColumns2 = this.ordersTableColumns6;
    }

    this.kpiid = kpiid;
    this.effdate = effective_date;
    this.getProTypes(this.kpiid);
  }

  public getProType(proType: string) {
    console.log(this.clickedKpiType);
    if (this.clickedKpiType === "By Product") {
      this.ordersTableColumns3 = this.ordersTableColumns3;
    } else if (this.clickedKpiType === "By Combo String") {
      this.ordersTableColumns3 = this.ordersTableColumns7;
    }

    this.proType = proType;
    this.getCats(this.kpiid, this.proType);
  }

  public getSelectedPros(cat: string) {
    this.cat = cat;
    this.getPros(this.kpiid, this.proType, this.cat);
  }

  public getProTypes(kpiid: number) {
    this.kpimasterService.getProTypes(kpiid, this.effdate)
      .subscribe((res: any) => {
        this.productTypes = res;

        //this.getCats(kpiid, this.kpiMasterModel.product_type);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  public getCats(kpiid: number, proType: string) {
    console.log("getCats called");

    this.kpimasterService.getCats(kpiid, proType, this.effdate)
      .subscribe((data: any) => {
        //console.log(JSON.stringify(data));
        this.productCats = data;
        //console.log(JSON.stringify(this.productCats));
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  public getPros(kpiid: number, proType: string, cat: string) {
    this.kpimasterService.getPros(kpiid, proType, cat, this.effdate)
      .subscribe((data: any) => {
        this.logger.info(data);
        this.productProducts = data;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  toggleCustomRoutineShow(event: any) {
    if (event.currentTarget.value === "Custom") {
      this.isCustomRoutineShown = !this.isCustomRoutineShown;
    } else {
      this.isCustomRoutineShown = false;
    }
  }

  editToggleShow(event: any) {
    if (event.currentTarget.value === "Custom") {
      this.isEditCustomRoutineShown = !this.isEditCustomRoutineShown;
    } else {
      this.isEditCustomRoutineShown = false;
    }
  }

  toggleShow(event: any) {
    if (event.currentTarget.value === "By KPI") {
      this.isProductsShown = false;
      this.isKpiShown = true;
      this.isComboShown = false;
    } else if (event.currentTarget.value === "By Combo String") {
      this.isProductsShown = false;
      this.isKpiShown = false;
      this.isComboShown = true;
    } else if (event.currentTarget.value === "By Product") {
      this.isProductsShown = true;
      this.isKpiShown = false;
      this.isComboShown = false;
    } else {
      this.isProductsShown = false;
      this.isKpiShown = false;
      this.isComboShown = false;
    }

  }

  getProductTypes() {
    this.kpimasterService.getProductTypes()
      .subscribe((data: any) => {
        this.productTypesData = data;
        this.filteredProductsTypeData = this.productTypesData.filter((v, i) => this.productTypesData.findIndex(item => item.product_type == v.product_type) === i);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  getCategories(event: any, index: number) {
    //console.log("index === " + index);
    // if (event.currentTarget.value === "All") {
    //   this.isCatShown = false;
    //   this.isProShown = false;
    // } else {
    //   this.isCatShown = true;
    //   this.isProShown = true;
    // }

    // Check duplicates
    // this.checkData = [];
    // this.duplicatecheckData = [];
    // this.duplicatecheckData = JSON.parse(JSON.stringify(this.prodsData));
    // this.duplicatecheckData.pop();
    // this.checkData = this.duplicatecheckData.filter((calcCtrl) => (calcCtrl.product_type == event.target.value));
    // if (this.checkData.length > 0) {
    //   this.notificationService.sendNotification(NotificationType.ERROR, "Please Select Diffrent or Remove ");
    // }

    // filter active categories based on product types
    const filterValue = this.globalService._normalizeValue(event.currentTarget.value);
    this.filteredCatData = this.productTypesData.filter(item => this.globalService._normalizeValue(item.product_type).startsWith(filterValue));
    this.filteredCatData = this.filteredCatData.filter((v, i) => this.filteredCatData.findIndex(item => item.product_category == v.product_category) === i);
    this.filteredCatData = this.filteredCatData.sort((a, b) => (a.product_category < b.product_category) ? -1 : 1);

    this.prodsData[index].product_category = this.filteredCatData;
    //console.log(this.prodsData[index].product_category);
  }

  getProducts(event: any, index: number) {
    //console.log("index === " + index);
    // if (event.currentTarget.value === "All") {
    //   this.isProShown = false;
    // } else {
    //   this.isProShown = true;
    // }
    // filter active products based on product type and product category
    const filterValue = this.globalService._normalizeValue(event.currentTarget.value);
    this.filteredProductsData = this.productTypesData.filter(item => this.globalService._normalizeValue(item.product_category).startsWith(filterValue));
    this.filteredProductsData = this.filteredProductsData.filter((v, i) => this.filteredProductsData.findIndex(item => item.product == v.product) === i);
    this.filteredProductsData = this.filteredProductsData.sort((a, b) => (a.product < b.product) ? -1 : 1);
    this.prodsData[index].product = this.filteredProductsData;
    //console.log(this.prodsData[index].product);
    //console.log(this.prodsData);
  }

  getEditProductTypes() {
    this.kpimasterService.getProductTypes()
      .subscribe((data: any) => {
        this.editProductTypesData = data;
        this.filteredEditProductsTypeData = this.editProductTypesData.filter((v, i) => this.editProductTypesData.findIndex(item => item.product_type == v.product_type) === i);
        this.editfilteredProductsTypeData = this.filteredEditProductsTypeData;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  getEditCategories(event: any, index: number) {

    // if (event.currentTarget.value === "All") {
    //   this.isCatShown = false;
    //   this.isProShown = false;
    // } else {
    //   this.isCatShown = true;
    //   this.isProShown = true;
    // }
    // filter active categories based on product types
    const filterValue = this.globalService._normalizeValue(event.currentTarget.value);
    this.editfilteredCatData = this.editProductTypesData.filter(item => this.globalService._normalizeValue(item.product_type).startsWith(filterValue));
    this.editfilteredCatData = this.editfilteredCatData.filter((v, i) => this.editfilteredCatData.findIndex(item => item.product_category == v.product_category) === i);
    this.editfilteredCatData = this.editfilteredCatData.sort((a, b) => (a.product_category < b.product_category) ? -1 : 1);
    this.editSelectedProductsData[index].product_category = this.editfilteredCatData;
  }

  getEditProducts(event: any, index: number) {
    // if (event.currentTarget.value === "All") {
    //   this.isProShown = false;
    // } else {
    //   this.isProShown = true;
    // }
    // filter active products based on product type and product category
    const filterValue = this.globalService._normalizeValue(event.currentTarget.value);
    this.editfilteredProductsData = this.editProductTypesData.filter(item => this.globalService._normalizeValue(item.product_category).startsWith(filterValue));
    this.editfilteredProductsData = this.editfilteredProductsData.sort((a, b) => (a.product < b.product) ? -1 : 1);
    this.editfilteredProductsData = this.editfilteredProductsData.filter((v, i) => this.editfilteredProductsData.findIndex(item => item.product == v.product) === i);
    this.editSelectedProductsData[index].product = this.editfilteredProductsData;
    console.log(this.editfilteredProductsData);
  }

  getSelectedProducts(kpiid: number, effective_date: Date) {
    this.editSelectedProductsData = [];
    const dt = new Date(effective_date);
    this.kpimasterService.getSelectedProducts(kpiid, dt).subscribe(
      (response: Kpimaster[]) => {
        this.editSelectedProductsData = response;
        console.log(JSON.stringify(this.editSelectedProductsData));

        if (this.editSelectedProductsData.length === 0) {
          console.log("Inside IF");
          this.kpiMasterModel.created_by = "";
          this.kpiMasterModel.created_dt = new Date();
          this.editSelectedProductsData.push(this.kpiMasterModel);
        }


        let i: number = 0;
        for (let mod of this.editSelectedProductsData) {
          console.log("Inside for loop");
          const filterValue = this.globalService._normalizeValue(mod.product_type);
          this.editfilteredCatData = this.editProductTypesData.filter(item => this.globalService._normalizeValue(item.product_type).startsWith(filterValue));
          this.editfilteredCatData = this.editfilteredCatData.filter((v, i) => this.editfilteredCatData.findIndex(item => item.product_category == v.product_category) === i);
          this.editfilteredCatData = this.editfilteredCatData.sort((a, b) => (a.product_category < b.product_category) ? -1 : 1);
          this.editSelectedProductsData[i].product_category = this.editfilteredCatData;

          mod.dupli_cat = mod.dupli_cat;

          const filterValue1 = this.globalService._normalizeValue(mod.dupli_cat);
          this.editfilteredProductsData = this.editProductTypesData.filter(item => this.globalService._normalizeValue(item.product_category).startsWith(filterValue1));
          this.editfilteredProductsData = this.editfilteredProductsData.sort((a, b) => (a.product < b.product) ? -1 : 1);
          this.editfilteredProductsData = this.editfilteredProductsData.filter((v, i) => this.editfilteredProductsData.findIndex(item => item.product == v.product) === i);
          this.editSelectedProductsData[i].product = this.editfilteredProductsData;

          mod.dupli_pro = mod.dupli_pro;

          i++;
        }
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    )
  }

  toggleShowEdit(event: any) {
    this.kpiMasterModel.created_by = "";
    this.kpiMasterModel.created_dt = new Date();
    console.log(this.kpiMasterModel);
    if (this.kpiType == "By Combo String") {
      this.dependKpiEditModels = [];
      this.editSelectedProductsData = [];
      this.dependKpiEditModels.push(this.kpiMasterModel);
      this.editSelectedProductsData.push(this.kpiMasterModel);
    } else if (this.kpiType == "By KPI") {
      this.kpiEditModels = [];
      this.kpiEditModels.push(this.kpiMasterModel);
      this.editSelectedProductsData = [];
      this.editSelectedProductsData.push(this.kpiMasterModel);
    } else if (this.kpiType == "By Product") {
      this.kpiEditModels = [];
      this.dependKpiEditModels = [];
      this.kpiEditModels.push(this.kpiMasterModel);
      this.dependKpiEditModels.push(this.kpiMasterModel);
    }

    if (event.currentTarget.value === "By KPI") {
      this.isEditProductsShown = false;
      this.isEditKpiShown = true;
      this.isEditComboShown = false;
    } else if (event.currentTarget.value === "By Combo String") {
      this.isEditProductsShown = false;
      this.isEditKpiShown = false;
      this.isEditComboShown = true;
    } else if (event.currentTarget.value === "By Product") {
      this.isEditProductsShown = true;
      this.isEditKpiShown = false;
      this.isEditComboShown = false;
    } else {
      this.isEditProductsShown = false;
      this.isEditKpiShown = false;
      this.isEditComboShown = false;
    }
  }

  public onEditKpi(kpimaster: Kpimaster): void {


    this.getDependentKpis();
    this.getChargebackDependentKpis(kpimaster.effective_date, kpimaster.id);

    if (kpimaster.kpi_calc_type === "Custom") {
      this.isEditCustomRoutineShown = true;
    } else {
      this.isEditCustomRoutineShown = false;
    }

    if (kpimaster.kpi_type === "By KPI") {
      this.isEditProductsShown = false;
      this.isEditKpiShown = true;
      this.isEditComboShown = false;
    } else if (kpimaster.kpi_type === "By Combo String") {
      this.isEditProductsShown = false;
      this.isEditKpiShown = false;
      this.isEditComboShown = true;
    } else if (kpimaster.kpi_type === "By Product") {
      this.isEditProductsShown = true;
      this.isEditKpiShown = false;
      this.isEditComboShown = false;
    } else {
      this.isEditProductsShown = false;
      this.isEditKpiShown = false;
      this.isEditComboShown = false;
    }
    this.kpiMasterModel = kpimaster;
    // console.log(this.kpiMasterModel);
    this.clickButton('openKpiEdit');

    if (this.kpiMasterModel.kpi_type == "By Combo String") {
      this.getPositionsValues(this.kpiMasterModel.id, this.kpiMasterModel.effective_date);
    } else if (this.kpiMasterModel.kpi_type == "By KPI") {
      this.getDependKpis(this.kpiMasterModel.id, this.kpiMasterModel.effective_date);
    } else if (this.kpiMasterModel.kpi_type == "By Product") {
      this.getSelectedProducts(this.kpiMasterModel.id, this.kpiMasterModel.effective_date);
    }

  }

  getPositionsValues(kpiid: number, effective_date: Date) {
    this.kpiEditModels = [];
    const dt = new Date(effective_date);
    //console.log(dt);
    this.kpimasterService.getPositionsValues(kpiid, dt).subscribe(
      (response: Kpimaster[]) => {
        this.kpiEditModels = response;
        console.log(this.kpiEditModels);
        if (this.kpiEditModels.length === 0) {
          console.log("Inside IF");
          this.kpiMasterModel.created_by = "";
          this.kpiMasterModel.created_dt = new Date();
          this.kpiEditModels.push(this.kpiMasterModel);
        }
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    )
  }

  getDependKpis(kpiid: number, effective_date: Date) {
    this.dependKpiEditModels = [];
    const dt = new Date(effective_date);
    // console.log(dt);
    this.kpimasterService.getDependKpis(kpiid, dt).subscribe(
      (response: Kpimaster[]) => {
        this.dependKpiEditModels = response;
        //console.log(JSON.stringify(this.dependKpiEditModels));

        if (this.dependKpiEditModels.length === 0) {
          console.log("Inside IF");
          this.kpiMasterModel.created_by = "";
          this.kpiMasterModel.created_dt = new Date();
          this.dependKpiEditModels.push(this.kpiMasterModel);
        }

        for (let mod of this.dependKpiEditModels) {
          // console.log(mod);
          this.kpiMasterModel.depndentKpis = mod.depndentKpis;
        }
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    )
  }

  hideRemainingLabels(id: number): boolean {
    if (id === 0)
      return true;
    else
      return false;
  }
  addNewComboRow(kpiForm: NgForm) {
    const kpiObj = new Kpimaster();
    kpiObj.combo_position = this.kpiMasterModel1.combo_position;
    kpiObj.combo_values = this.kpiMasterModel1.combo_values;
    this.kpiModels.push(kpiObj);
    console.log(this.kpiModels);
  }
  public removeComboRow(index: any) {
    if (this.kpiModels.length > 1) {
      if (this.kpiModels[index].combo_position != null) {
        this.removeComboFilterData(index);
      } else {
        this.removeComboFilterData(index);
        //this.kpiModels.splice(index, 1);
      }
    } else {
      this.notificationService.sendNotification(NotificationType.WARNING, "There Is Only One Row Exist You Can't Delete.");
    }
  }
  private removeComboFilterData(i: any) {

    if (this.kpiModels.length > 0) {
      const compos = this.kpiModels[i].combo_position;
      this.kpiModels.forEach((value: any, index: any) => {
        if (value.combo_position == compos)
          this.kpiModels.splice(index, 1);
      })
    }
    console.log(this.kpiModels);
  }

  addNewRowKpi(kpiForm: NgForm) {
    const kpiObj = new Kpimaster();
    kpiObj.id = this.kpiMasterModel2.id;
    kpiObj.includecount = true;
    kpiObj.includerevenue = true;
    this.byKpiModels.push(kpiObj);
  }

  public removeRowKpi(index: any) {
    if (this.byKpiModels.length > 1) {
      if (this.byKpiModels[index].id != null) {
        this.removeFilterDataKpi(index);
      }
      else {
        this.removeFilterDataKpi(index);
        this.byKpiModels.splice(index, 1);
      }
    } else {
      this.notificationService.sendNotification(NotificationType.WARNING, "There Is Only One Row Exist You Can't Delete.");
    }
  }
  private removeFilterDataKpi(i: any) {
    if (this.byKpiModels.length > 0) {
      const compos = this.byKpiModels[i].id;
      this.byKpiModels.forEach((value: any, index: any) => {
        if (value.id == compos)
          this.byKpiModels.splice(index, 1);
      })
    }
  }

  addByProductRow(kpiForm: NgForm) {
    const kpiObj = new Kpimaster();
    kpiObj.product_type = this.kpiMasterModel3.product_type;
    kpiObj.product_category = this.kpiMasterModel3.product_category;
    kpiObj.product = this.kpiMasterModel3.product;
    this.prodsData.push(kpiObj);
    //console.log("add prodsData = " + JSON.stringify(this.prodsData));
  }
  public removeByProductRow(index: any) {
    if (this.prodsData.length > 1) {
      if (this.prodsData[index].product != null) {
        this.removeByProductFilterData(index);
      }
      else {
        this.removeByProductFilterData(index);
        this.prodsData.splice(index, 1);
      }
    } else {
      this.notificationService.sendNotification(NotificationType.WARNING, "There Is Only One Row Exist You Can't Delete.");
    }
  }
  private removeByProductFilterData(i: any) {
    if (this.prodsData.length > 0) {
      const compos = this.prodsData[i].product;
      this.prodsData.forEach((value: any, index: any) => {
        if (value.product == compos)
          this.prodsData.splice(index, 1);
      })
    }
  }

  addNewComboEditRow(kpiForm: NgForm) {
    const kpiObj = new Kpimaster();
    kpiObj.combo_position = this.kpiMasterModel4.combo_position;
    kpiObj.combo_values = this.kpiMasterModel4.combo_values;
    this.kpiEditModels.push(kpiObj);
    //console.log("add kpiEditModels = " + JSON.stringify(this.kpiEditModels));
  }
  public removeComboEditRow(index: any) {
    if (this.kpiEditModels.length > 1) {
      if (this.kpiEditModels[index].combo_position != null) {
        this.removeComboEditFilterData(index);
      }
      else {
        this.removeComboEditFilterData(index);
        this.kpiEditModels.splice(index, 1);
      }
    } else {
      this.notificationService.sendNotification(NotificationType.WARNING, "There Is Only One Row Exist You Can't Delete.");
    }
  }
  private removeComboEditFilterData(i: any) {
    if (this.kpiEditModels.length > 0) {
      const compos = this.kpiEditModels[i].combo_position;
      this.kpiEditModels.forEach((value: any, index: any) => {
        if (value.combo_position == compos)
          this.kpiEditModels.splice(index, 1);
      })
    }
  }

  addByKPIEditRow(kpiForm: NgForm) {
    const kpiObj = new Kpimaster();
    kpiObj.depndentKpis = this.kpiMasterModel5.depndentKpis;
    this.dependKpiEditModels.push(kpiObj);
    //console.log("add dependKpiEditModels = " + JSON.stringify(this.dependKpiEditModels));
  }
  public removeByKPIEditRow(index: any) {
    if (this.dependKpiEditModels.length > 1) {
      if (this.dependKpiEditModels[index].depndentKpis != null) {
        this.removeByKPIEditFilterData(index);
      }
      else {
        this.removeByKPIEditFilterData(index);
        this.dependKpiEditModels.splice(index, 1);
      }
    } else {
      this.notificationService.sendNotification(NotificationType.WARNING, "There Is Only One Row Exist You Can't Delete.");
    }
  }
  private removeByKPIEditFilterData(i: any) {
    if (this.dependKpiEditModels.length > 0) {
      const compos = this.dependKpiEditModels[i].depndentKpis;
      this.dependKpiEditModels.forEach((value: any, index: any) => {
        if (value.depndentKpis == compos)
          this.dependKpiEditModels.splice(index, 1);
      })
    }
  }

  addByProductEditRow(kpiForm: NgForm) {
    const kpiObj = new Kpimaster();
    kpiObj.product_type = this.kpiMasterModel6.product_type;
    kpiObj.product_category = this.kpiMasterModel6.product_category;
    kpiObj.product = this.kpiMasterModel6.product;
    this.editSelectedProductsData.push(kpiObj);
    //console.log("add editSelectedProductsData = " + JSON.stringify(this.editSelectedProductsData));
  }
  public removeByProductEditRow(index: any) {
    if (this.editSelectedProductsData.length > 1) {
      if (this.editSelectedProductsData[index].product != null) {
        this.removeByProductEditFilterData(index);
      }
      else {
        this.removeByProductEditFilterData(index);
        this.editSelectedProductsData.splice(index, 1);
      }
    } else {
      this.notificationService.sendNotification(NotificationType.WARNING, "There Is Only One Row Exist You Can't Delete.");
    }
  }
  private removeByProductEditFilterData(i: any) {
    if (this.editSelectedProductsData.length > 0) {
      const compos = this.editSelectedProductsData[i].product;
      this.editSelectedProductsData.forEach((value: any, index: any) => {
        if (value.product == compos)
          this.editSelectedProductsData.splice(index, 1);
      })
    }
  }





  public onDeleteProduct(id: number): void {
    if (confirm("Are you sure to delete this product")) {
      this.subscriptions.push(
        this.kpimasterService.deleteProduct(id).subscribe(
          (response: CustomHttpRespone) => {
            this.notificationService.sendNotification(NotificationType.SUCCESS, response.message);
            //this.kpimasterService.clearCache();
            this.getActiveKpis();
          }, (errorResponse: HttpErrorResponse) => {
            var msg: any;
            msg = errorResponse;
            this.notificationService.sendNotification(NotificationType.ERROR, msg);
          }
        )
      );
    }
  }

  public clickToCloseButton(buttonId: string, kpiForm: NgForm): void {
    this.isProductsShown = false;
    this.isKpiShown = false;
    this.isComboShown = false;
    document.getElementById(buttonId).click();
    kpiForm.reset();
    // added for addrow functionality
    this.kpiModels = [];
    this.byKpiModels = [];
    this.prodsData = [];
    this.kpiMasterModel.created_by = "";
    this.kpiMasterModel.created_dt = new Date();
    this.kpiModels.push(this.kpiMasterModel);
    this.byKpiModels.push(this.kpiMasterModel);
    this.prodsData.push(this.kpiMasterModel);


  }

  public clickToEditCloseButton(buttonId: string, kpiForm: NgForm): void {
    this.isEditProductsShown = false;
    this.isEditKpiShown = false;
    this.isEditComboShown = false;
    document.getElementById(buttonId).click();

  }



  public updateKpiStatusToActive() {
    this.kpimasterService.updateKpiStatusToActive(this.selctedKpis)
      .subscribe(response => {
        //this.getInactiveKpis(false);
        // this.kpimasterService.clearCache();
        this.getActiveKpis();
        //response = response as ErrorResponseMessage;
        this.selctedKpis = [];
        this.isChecked = false;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      })
  }

  public updateKpiStatusToInactive() {
    this.kpimasterService.updateKpiStatusToInactive(this.selctedKpis)
      .subscribe(response => {
        //this.kpimasterService.clearCache();
        this.getActiveKpis();
        //response = response as ErrorResponseMessage;
        this.selctedKpis = [];
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      })
  }

  getTranslateData() {
    this.kpimasterService.getAdminConfigData()
      .subscribe((data: any) => {
        this.translateMasterdata = data;
        this.getFeedType();
        this.getKpiTypeOne();
        this.getKPICalc();
        this.getComboString();
        this.getWstatString();
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }
  getFeedType() {
    const filterValue = this.globalService._normalizeValue('Feed Type');
    this.feedTypeData = this.translateMasterdata.filter(comm => this.globalService._normalizeValue(comm.trans_field_name).startsWith(filterValue));
    this.feedTypeData = this.feedTypeData.sort((a, b) => (a.trans_field_value < b.trans_field_value) ? -1 : 1);
  }
  getKpiTypeOne() {
    const filterValue = this.globalService._normalizeValue('KPI Type Simple/Complex');
    this.kpiTypeOnedata = this.translateMasterdata.filter(comm => this.globalService._normalizeValue(comm.trans_field_name).startsWith(filterValue));
    this.kpiTypeOnedata = this.kpiTypeOnedata.sort((a, b) => (a.trans_field_value < b.trans_field_value) ? -1 : 1);
  }
  getComboString() {
    const filterValue = this.globalService._normalizeValue('By Combo String');
    this.comboStringData = this.translateMasterdata.filter(comm => this.globalService._normalizeValue(comm.trans_field_name).startsWith(filterValue));
    this.comboStringData = this.comboStringData.sort((a, b) => (a.trans_field_value < b.trans_field_value) ? -1 : 1);
  }
  getWstatString() {
    const filterValue = this.globalService._normalizeValue('Wstat String');
    this.wstatStringData = this.translateMasterdata.filter(comm => this.globalService._normalizeValue(comm.trans_field_name).startsWith(filterValue));
    this.wstatStringData = this.wstatStringData.sort((a, b) => (a.trans_field_value < b.trans_field_value) ? -1 : 1);
  }
  public getKPICalc(): void {
    const filterValue = this.globalService._normalizeValue('KPI Calc Type');
    this.kpicalctypesdata = this.translateMasterdata.filter(comm => this.globalService._normalizeValue(comm.trans_field_name).startsWith(filterValue));
    this.kpicalctypesdata = this.kpicalctypesdata.sort((a, b) => (a.trans_field_value < b.trans_field_value) ? -1 : 1);
    this.editkpicalctypesdata = this.kpicalctypesdata;
  }

  public getDependentKpis() {
    this.kpimasterService.getDependentKpis()
      .subscribe((response: any) => {
        this.dependentKpisList = response;
        this.filterKPiData = JSON.parse(JSON.stringify(response));
        //this.dependentKpisList = this.dependentKpisList.filter((v, i) => this.dependentKpisList.findIndex(item => item.kpi_name == v.kpi_name) === i);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  public getChargebackDependentKpis(effective_date: any, id: any) {
    this.kpimasterService.getChargebackDependentKpis(effective_date, id)
      .subscribe((response: any) => {
        this.depndntScoreKpiEditList = response;
        //console.log(this.depndntScoreKpiEditList);
        if (this.depndntScoreKpiEditList.length === 0) {
          this.depndntScoreKpiModel.created_by = "";
          this.depndntScoreKpiModel.created_dt = new Date();
          this.depndntScoreKpiEditList.push(this.depndntScoreKpiModel);
        }
        //this.filterKPiData = JSON.parse(JSON.stringify(response));
        //this.dependentKpisList = this.dependentKpisList.filter((v, i) => this.dependentKpisList.findIndex(item => item.kpi_name == v.kpi_name) === i);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  public getInactiveKpis(): void {
    // console.log(this.kpis);
    this.kpisData = this.kpis;
  }

  public getActiveKpisData(): void {
    // console.log(this.filterKPiData);
    this.kpisData = this.activeKpisData;
  }

  changed(values: any) {
    this.isChecked = values.value.currentTarget.checked;

    if (values.value.currentTarget.checked == true) {
      this.getInactiveKpis();
    } else {
      this.getActiveKpisData();
    }
  }

  changedDate(values: any) {
    // console.log(values.value.target.value);
    this.getActiveKpisByDate(values.value.target.value);
  }

  refreshPage() {
    location.reload();
  }

  public selectedActiveKpis(kpi: Kpimaster, values: any) {
    if (values.currentTarget.checked) {
      this.selctedKpis.push(kpi);
    } else {
      this.selctedKpis.forEach((value: any, index: any) => {
        if (value.id == kpi.id) this.selctedKpis.splice(index, 1);
      });
    }
  }

  public selectedInactiveKpis(kpi: Kpimaster, values: any) {
    if (values.currentTarget.checked) {
      this.selctedKpis.push(kpi);
    } else {
      this.selctedKpis.forEach((value: any, index: any) => {
        if (value.id == kpi.id) this.selctedKpis.splice(index, 1);
      });
    }
  }

  redirect(url: string) {
    this.router.navigate(['/' + url]);
  }

  // GRID FRAMEWORK
  innerRowAction1(row: any) {
    // console.log("row = " + JSON.stringify(row.row));
    if (row.value === 'View') {
      this.getKpiId(row.row.id, row.row.effective_date, row.row.kpi_type);
    }
    if (row.value === 'Update') {
      this.kpiType = row.row.kpi_type;
      this.originalKPIName = row.row.kpi_name;
      this.originalEdate = row.row.effective_date;
      // console.log(this.originalEdate);
      this.onEditKpi(row.row);
    }

    this.selectedKpiId = row.row.id;
    //console.log(this.selectedKpiId);

  }

  innerRowAction2(row: any) {
    if (row.value === 'View') {
      this.getProType(row.row.product_type);
    }
  }

  innerRowAction3(row: any) {
    if (row.value === 'View') {
      this.getSelectedPros(row.row.product_category);
    }
  }

  innerRowAction4(row: any) {
    if (this.isAccessDisabled === true) {
      this.notificationService.sendNotification(NotificationType.WARNING, NotificationType.PERMISSIONS_MSG);
    } else {
      this.onDeleteProduct(row.row.id);
    }
  }

  actionOnButton(action: any) {
    if (action === "Add") {
      if (this.isAccessDisabled === true) {
        this.notificationService.sendNotification(NotificationType.WARNING, NotificationType.PERMISSIONS_MSG);
      } else {
        this.clickButton(action);
      }
    } else if (action === "Active") {
      if (this.isAccessDisabled === true) {
        this.notificationService.sendNotification(NotificationType.WARNING, NotificationType.PERMISSIONS_MSG);
      } else {
        this.updateKpiStatusToActive();
      }
    } else if (action === "Inactive") {
      if (this.isAccessDisabled === true) {
        this.notificationService.sendNotification(NotificationType.WARNING, NotificationType.PERMISSIONS_MSG);
      } else {
        this.updateKpiStatusToInactive();
      }
    }
  }

  private clickButton(buttonId: string): void {
    document.getElementById(buttonId).click();
  }

  update(user: any, values: any) {
    console.log("update called");
    if (values.value.currentTarget.checked) {
      this.selctedKpis.push(user.row);
    } else {
      this.selctedKpis.forEach((value: any, index: any) => {
        if (value.kpi_name == user.row.kpi_name) this.selctedKpis.splice(index, 1);
      });
    }
  }

  exportExcel() {
    console.log(this.excelKpis);
    for (let js of this.excelKpis) {

      delete js.created_dt;
      delete js.created_by;
      delete js.update_dt;
      delete js.updated_by;
      delete js.measure_type;
      delete js.products;
      delete js.trans_field_value;
      delete js.productid;
      delete js.depndentKpis;
      delete js.edate;
      delete js.trans_field_name;
      delete js.combo_position;
      delete js.combo_string;
      delete js.custom_routine;
      delete js.dupli_cat;
      delete js.dupli_pro;
      delete js.include_count;
      delete js.include_revenue;
      delete js.includecount;
      delete js.includerevenue;
      delete js.kpi_priority;
      delete js.product;
      delete js.product_category;
      delete js.product_type;
      delete js.combo_values;
      delete js.stat;
      delete js.ch_kpiid;
      delete js.chargeback_depndt_kpi_id;
      delete js.chargeback_effective_date;
      delete js.chargeback_kpiid;
    }

    this.dataForExcel = [];
    let reportData = null;
    this.excelKpis.forEach((row: any) => {
      this.dataForExcel.push(Object.values(row))
    })
    // console.log(this.ordersTableExcelHeaderColumns);
    reportData = {
      title: 'KPI Details',
      data: this.dataForExcel,
      headers: Object.keys(this.ordersTableExcelHeaderColumns)
    }
    this.ete.exportExcel(reportData);
  }

  initializeExcelHeaders(): void {
    this.excelHeadersService.getKPIExcelHeaders()
      .subscribe((data: any) => {
        this.columnsDataJson = JSON.parse(JSON.stringify(data));
        this.columnsExcelData = JSON.parse(JSON.stringify(data));

        this.ordersTableColumns1 = this.columnsDataJson.filter((kpi: { pagename: string; }) => kpi.pagename === "KPI");
        this.ordersTableColumns2 = this.columnsDataJson.filter((kpi: { pagename: string; }) => kpi.pagename === "KPIMasterProductTypeData");
        this.ordersTableColumns3 = this.columnsDataJson.filter((kpi: { pagename: string; }) => kpi.pagename === "KPIMasterProductCatData");
        this.ordersTableColumns4 = this.columnsDataJson.filter((kpi: { pagename: string; }) => kpi.pagename === "KPIMasterProductData");
        this.ordersTableColumns5 = this.columnsDataJson.filter((kpi: { pagename: string; }) => kpi.pagename === "KPIMasterProductTypeByKPI");
        this.ordersTableColumns6 = this.columnsDataJson.filter((kpi: { pagename: string; }) => kpi.pagename === "KPIMasterProductTypeByCombo");
        this.ordersTableColumns7 = this.columnsDataJson.filter((kpi: { pagename: string; }) => kpi.pagename === "KPIMasterProductCatByCombo");

        // console.log(this.columnsExcelData);
        this.columnsExcelData = this.columnsExcelData.filter((kpi: { pagename: string; }) => kpi.pagename === "KPI");
        // console.log(this.columnsExcelData);
        var obj = [];
        for (let val of this.columnsExcelData) {
          obj[val.name] = val.name;
          //  console.log(obj);
        }
        this.ordersTableExcelHeaderColumns = obj;
        // console.log(this.ordersTableExcelHeaderColumns);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  initializeColumns(): void {



    this.actions = [
      {
        name: 'Update',
        dataKey: 'fas fa-edit success f-25',
        position: 'left',
        isSortable: false,
        class: 'badge bg-success'
      },
      {
        name: 'Delete',
        dataKey: 'fas fa-trash-alt danger f-25',
        position: 'left',
        isSortable: false,
        class: 'badge bg-danger'
      }
    ]

    this.actionButtons = [
      {
        name: 'Add',
        class: 'btn btn-primary btn-xs'
      },
      {
        name: 'Active',
        class: 'btn btn-success btn-xs'
      },
      {
        name: 'Inactive',
        class: 'btn btn-danger btn-xs'
      }
    ]

  }

  isLastDayOfMonth(date: Date | null): boolean {
    date = date ?? new Date();
    const dayOfMonth = date.getDate();
    const lastDayOfMonth = getLastDayOfMonth(date);

    return dayOfMonth === lastDayOfMonth;
  };

}

function getLastDayOfMonth(date: Date): number {
  return new Date(date.getFullYear(), date.getMonth(), 1).getDate();
}